import {Observable} from 'rxjs'
import {ProDirectoryPage} from '../types/pro-directory-page.types'
import {map} from 'rxjs/operators'
import {GetProDirectoryPageGql} from '../../../../__generated__/datocms.types'
import {TranslocoService} from '@ngneat/transloco'
import {getSiteLocale} from '../site-locale'
import {pickProperty} from '../../graphql/graphql-utils'
import {parseProDirectoryPage} from '../serde/pro-directory-page.serde'
import {Injectable} from '@angular/core'
import {CMS_GRAPHQL_CLIENT_NAME} from '../content-graphql-split'

@Injectable()
export class ProDirectoryPageContentService {
  constructor(
    private readonly getProDirectoryPageGql: GetProDirectoryPageGql,
    private readonly locale: TranslocoService,
  ) {}

  getProDirectoryPage(): Observable<ProDirectoryPage> {
    return this.getProDirectoryPageGql
      .fetch({locale: getSiteLocale(this.locale), type: 'Default'}, {context: {clientName: CMS_GRAPHQL_CLIENT_NAME}})
      .pipe(
        map(page => pickProperty(page.data, 'proDirectoryPageModel')),
        map(page => parseProDirectoryPage(page)),
      )
  }
}
